export default __webpack_public_path__ + "static/media/guide0304_m.e9f4275f.jpg";